var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "left-side-class": "col-xl-4 pb-2",
          page: _vm.headerConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _c("board", { attrs: { details: _vm.detailsBoard } }),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c("expectation", {
            ref: "answers",
            attrs: { input: _vm.model.answers, "is-read-only": _vm.isReadOnly },
            on: {
              "update:input": function($event) {
                return _vm.$set(_vm.model, "answers", $event)
              },
              add: _vm.addAnswer,
              quit: _vm.quitAnswer
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c("sections", {
            ref: "sections",
            attrs: {
              answers: _vm.model.answers,
              input: _vm.model.sections,
              "is-read-only": _vm.isReadOnly,
              status: _vm.model.status
            },
            on: {
              "update:input": function($event) {
                return _vm.$set(_vm.model, "sections", $event)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c("additional-questions", {
            ref: "additionalQuestions",
            attrs: {
              input: _vm.model.additionalQuestions,
              "is-read-only": _vm.isReadOnly
            },
            on: {
              "update:input": function($event) {
                return _vm.$set(_vm.model, "additionalQuestions", $event)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c("evaluation", {
            ref: "evaluation",
            attrs: {
              "is-read-only": _vm.isReadOnly,
              sections: _vm.model.sections
            },
            model: {
              value: _vm.model.evaluationConfig,
              callback: function($$v) {
                _vm.$set(_vm.model, "evaluationConfig", $$v)
              },
              expression: "model.evaluationConfig"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }